import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { fromEvent, merge, of, Subscription } from 'rxjs';
import { delay, map, switchMap, tap } from 'rxjs/operators';
import { temChat } from '../categoria-cliente';
import { PerfilService } from '../services/ajs-perfil.service';
import { UiRouterState } from '../services/ajs-router-state.service';
import { ChatService } from '../services/chat.service';
import { FaqService } from '../services/faq.service';
import { SelectTourDialogComponent } from '../tour/select-tour-dialog/select-tour-dialog.component';

const TWO_SECONDS = 2 * 1000;

@Component({
  selector: 'mandae-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss']
})
export class SideMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  public items = [
    { matIcon: 'home', description: 'Início', state: 'home' },
    { svgIcon: 'menu:collection', description: 'Coletas', state: 'pedido' },
    { svgIcon: 'menu:package', description: 'Encomendas', state: 'historico' },
    { svgIcon: 'menu:charts', description: 'Indicadores', state: 'indicadores' },
    { svgIcon: 'financial:money', description: 'Financeiro', state: 'financeiro' },
    { svgIcon: 'menu:chat', description: 'Relacionamento', state: 'relacionamento' },
    { svgIcon: 'menu:settings', description: 'Configurações', state: 'perfil' },
  ];

  public wide = false;
  public hovering = false;
  public chatButton = false;

  @ViewChild('menuContainer')
  public menuContainerElement: ElementRef<HTMLDivElement>;

  private mouseSubscription: Subscription;

  private readonly MENU_SHOW_DELAY = TWO_SECONDS;

  constructor(
    private state: UiRouterState,
    private perfilService: PerfilService,
    private chatService: ChatService,
    private faqService: FaqService,
    private dialog: MatDialog,
  ) { }

  public ngOnInit() {
    this.botoesAjuda();
  }

  public ngAfterViewInit() {
    const mouseEnterEvent = fromEvent(this.menuContainerElement.nativeElement, 'mouseenter');
    const mouseLeaveEvent = fromEvent(this.menuContainerElement.nativeElement, 'mouseleave');

    const isInsideMenu = merge(
      mouseEnterEvent.pipe(map(() => true)),
      mouseLeaveEvent.pipe(map(() => false)),
    );

    this.mouseSubscription = isInsideMenu.pipe(
      switchMap(status => status ? of(status).pipe(delay(this.MENU_SHOW_DELAY)) : of(status)),
      tap(status => this.hovering = status),
    ).subscribe();
  }

  public ngOnDestroy() {
    if (this.mouseSubscription) {
      this.mouseSubscription.unsubscribe();
    }
  }

  public makeUrl(state: string) {
    return this.state.href(state, {});
  }

  public gotoState(state: string) {
    return this.state.go(state);
  }

  public isActive(state: string) {
    return this.state.includes(state);
  }

  public botoesAjuda() {
    const user = this.perfilService.getCacheUserData();

    if (user && temChat(user)) {
      this.chatButton = true;
    }
  }

  public initChat() {
    this.chatService.showChatWindow();
  }

  public initFaq() {
    this.faqService.showFaqWindow();
  }

  public initTour() {
    this.dialog.open(SelectTourDialogComponent);
  }

}
